import { render, staticRenderFns } from "./identityIndex.vue?vue&type=template&id=67264802&"
import script from "./identityIndex.vue?vue&type=script&lang=js&"
export * from "./identityIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports